<section xmlns="http://www.w3.org/1999/html">
  <h6>Field settings</h6>
  <ul data-uk-accordion="multiple: true">
    <li class="uk-open">
      <a class="uk-accordion-title" href>General</a>
      <div class="uk-accordion-content ">
        <div class="uk-margin">
          <label for="fieldType" class="uk-text-muted uk-text-bold">Input type</label>
          <select id="fieldType" type="select" class="uk-select" [(ngModel)]="field.typeInfo.type">
            <option value="string">Simple input</option>
            <option value="richText">Rich text</option>
            <option value="largeText">Text area</option>
          </select>
        </div>
        <div class="uk-margin">
          <label for="placeholder" class="uk-text-muted uk-text-bold">Placeholder</label>
          <input id="placeholder" type="text" class="uk-input" [(ngModel)]="field.form.placeholder"
                 (ngModelChange)="setPlaceholderWithReferenceUpdate()">
        </div>
      </div>
    </li>
    <li class="uk-open">
      <a class="uk-accordion-title" href>Label</a>
      <div class="uk-accordion-content">
        <div class="uk-margin">
          <label for="label" class="uk-text-muted uk-text-bold">Text</label>
          <div class="uk-form-controls">
            <ckeditor id="label" [editor]="editor" [(ngModel)]="field.label.text"
                      [config]="{placeholder: 'Field label'}">
            </ckeditor>
          </div>
        </div>
        <div class="uk-margin">
          <label for="labelCSS" class="uk-text-muted uk-text-bold">CSS classes</label>
          <input id="labelCSS" type="text" class="uk-input" [(ngModel)]="field.label.cssClasses">
        </div>
        <div class="uk-margin">
          <label for="labelStyles" class="uk-text-muted uk-text-bold">Styles</label>
          <input id="labelStyles" type="text" class="uk-input" [(ngModel)]="field.label.style">
        </div>
      </div>
    </li>
    <li>
      <a class="uk-accordion-title" href>Description</a>
      <div class="uk-accordion-content">
        <div class="uk-margin">
          <label for="descriptionText" class="uk-text-muted uk-text-bold">Text</label>
          <div class="uk-form-controls">
            <ckeditor id="descriptionText" [editor]="editor"
                      [(ngModel)]="field.form.description.text"
                      [config]="{placeholder: 'Give a description for the field'}">
            </ckeditor>
          </div>
        </div>
        <div class="uk-margin">
          <input id="descriptionShowMore" class="uk-checkbox" type="checkbox"
                 [(ngModel)]="field.form.description.showLess">
          <label for="descriptionShowMore" class="uk-checkbox-label uk-margin-small-left">Show less</label>
        </div>
        <div class="uk-margin">
          <label for="descriptionCSS" class="uk-text-muted uk-text-bold">CSS classes</label>
          <input id="descriptionCSS" type="text" class="uk-input" [(ngModel)]="field.form.description.cssClasses">
        </div>
        <div class="uk-margin">
          <label for="descriptionStyles" class="uk-text-muted uk-text-bold">Styles</label>
          <input id="descriptionStyles" type="text" class="uk-input" [(ngModel)]="field.form.description.style">
        </div>
      </div>
    </li>
    <li>
      <a class="uk-accordion-title" href>Suggestion</a>
      <div class="uk-accordion-content">
        <div class="uk-margin">
          <label for="suggestionText" class="uk-text-muted uk-text-bold">Text</label>
          <div class="uk-form-controls">
            <ckeditor id="suggestionText" [editor]="editor"
                      [(ngModel)]="field.form.suggestion.text"
                      [config]="{placeholder: 'Give a short suggestion for the field'}">
            </ckeditor>
          </div>
        </div>
        <div class="uk-margin">
          <label for="suggestionCSS" class="uk-text-muted uk-text-bold">CSS classes</label>
          <input id="suggestionCSS" type="text" class="uk-input" [(ngModel)]="field.form.suggestion.cssClasses">
        </div>
        <div class="uk-margin">
          <label for="suggestionStyles" class="uk-text-muted uk-text-bold">Styles</label>
          <input id="suggestionStyles" type="text" class="uk-input" [(ngModel)]="field.form.suggestion.style">
        </div>
      </div>
    <li>
      <a class="uk-accordion-title" href>Advanced</a>
      <div class="uk-accordion-content ">
        <div class="uk-text-muted uk-text-bold">
          <input id="fieldMandatory" class="uk-checkbox" type="checkbox" [(ngModel)]="field.form.mandatory">
          <label for="fieldMandatory" class="uk-checkbox-label uk-margin-small-left">Require this field</label>
        </div>
        <div class="uk-text-muted uk-text-bold">
          <input id="multiplicity" class="uk-checkbox" type="checkbox" [(ngModel)]="field.typeInfo.multiplicity">
          <label for="multiplicity" class="uk-checkbox-label uk-margin-small-left">Allow multiplicity</label>
        </div>
        <div class="uk-text-muted uk-text-bold">
          <input id="hidden" class="uk-checkbox" type="checkbox" [ngModel]="!field.form.display.visible"
                 (ngModelChange)="setVisibility($event)">
          <label for="hidden" class="uk-checkbox-label uk-margin-small-left">Hide field</label>
        </div>
        <div class="uk-margin">
          <div class="uk-flex uk-flex-middle">
            <label for="fieldName" class="uk-text-muted uk-text-bold uk-flex uk-flex-middle">JSON model field name
              <span class="material-symbols-sharp"
                    data-uk-tooltip="Define the property name in the answer JSON object. If none provided the field id will be used instead. (A unique name is recommended).">info</span>
            </label>
          </div>
          <input id="fieldName" type="text" class="uk-input" [(ngModel)]="field.name">
        </div>
      </div>
    </li>
  </ul>

</section>
